import axios from 'axios';
import {
  GET_ALL_TATA_RECORDS_REQUEST,
  GET_ALL_TATA_RECORDS_SUCCESS,
  GET_ALL_TATA_RECORDS_FAIL,
  GET_TATA_RECORD_BY_ID_REQUEST,
  GET_TATA_RECORD_BY_ID_SUCCESS,
  GET_TATA_RECORD_BY_ID_FAIL,
  CREATE_TATA_RECORD_REQUEST,
  CREATE_TATA_RECORD_SUCCESS,
  CREATE_TATA_RECORD_FAIL,
  UPDATE_TATA_RECORD_REQUEST,
  UPDATE_TATA_RECORD_SUCCESS,
  UPDATE_TATA_RECORD_FAIL,
  DELETE_TATA_RECORD_REQUEST,
  DELETE_TATA_RECORD_SUCCESS,
  DELETE_TATA_RECORD_FAIL,
  BULK_DELETE_TATA_RECORDS_REQUEST,
  BULK_DELETE_TATA_RECORDS_SUCCESS,
  BULK_DELETE_TATA_RECORDS_FAIL,
  CLEAR_ALL_TATA_RECORDS_REQUEST,
  CLEAR_ALL_TATA_RECORDS_SUCCESS,
  CLEAR_ALL_TATA_RECORDS_FAIL,
  IMPORT_TATA_RECORDS_REQUEST,
  IMPORT_TATA_RECORDS_SUCCESS,
  IMPORT_TATA_RECORDS_FAIL,
  IMPORT_TATA_PROGRESS_UPDATE,
  IMPORT_TATA_PROGRESS_RESET,
  EXPORT_TATA_RECORDS_REQUEST,
  EXPORT_TATA_RECORDS_SUCCESS,
  EXPORT_TATA_RECORDS_FAIL,
  GET_TATA_STATS_REQUEST,
  GET_TATA_STATS_SUCCESS,
  GET_TATA_STATS_FAIL,
  GET_TATA_BY_FILTERS_REQUEST,
  GET_TATA_BY_FILTERS_SUCCESS,
  GET_TATA_BY_FILTERS_FAIL,
} from '../constants/tataConstants';

import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

// Get all TATA records with search and pagination
export const fetchAllTataRecords = (queryParams) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ALL_TATA_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${baseUrl}/tata${queryParams ? `?${queryParams}` : ''}`, config);

    dispatch({
      type: GET_ALL_TATA_RECORDS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_ALL_TATA_RECORDS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get TATA record by ID
export const fetchTataRecordById = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_TATA_RECORD_BY_ID_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${baseUrl}/tata/${id}`, config);

    dispatch({
      type: GET_TATA_RECORD_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_TATA_RECORD_BY_ID_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Create TATA record
export const createTataRecord = (record) => async (dispatch, getState) => {
  try {
    dispatch({ type: CREATE_TATA_RECORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/tata`, record, config);

    dispatch({
      type: CREATE_TATA_RECORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: CREATE_TATA_RECORD_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update TATA record
export const updateTataRecord = (id, record) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_TATA_RECORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/tata/${id}`, record, config);

    dispatch({
      type: UPDATE_TATA_RECORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: UPDATE_TATA_RECORD_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Delete TATA record
export const deleteTataRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_TATA_RECORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/tata/${id}`, config);

    dispatch({
      type: DELETE_TATA_RECORD_SUCCESS,
      payload: id,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: DELETE_TATA_RECORD_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Bulk delete TATA records
export const bulkDeleteTataRecords = (ids) => async (dispatch, getState) => {
  try {
    dispatch({ type: BULK_DELETE_TATA_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    if (!userInfo?.token) {
      throw new Error('Authentication required');
    }

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Convert to array if it isn't already
    const idsArray = Array.isArray(ids) ? ids : [ids];

    const { data } = await axios.post(
      `${baseUrl}/tata/bulk-delete`,
      { ids: idsArray },
      config
    );

    dispatch({
      type: BULK_DELETE_TATA_RECORDS_SUCCESS,
      payload: data,
    });

    return { success: true, deletedCount: data.deletedCount };
  } catch (error) {
    dispatch({
      type: BULK_DELETE_TATA_RECORDS_FAIL,
      payload: error.response?.data?.message || error.message,
    });

    throw error;
  }
};

// Clear all TATA records
export const clearAllTataRecords = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_ALL_TATA_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/tata/clear-all`,
      { confirm: 'YES_DELETE_ALL' },
      config
    );

    dispatch({
      type: CLEAR_ALL_TATA_RECORDS_SUCCESS,
      payload: data,
    });

    return { success: true, deletedCount: data.deletedCount };
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: CLEAR_ALL_TATA_RECORDS_FAIL,
      payload: error.response?.data?.message || error.message,
    });

    throw error;
  }
};

// Enhanced Import TATA records with progress tracking
export const importTataRecords = (file, clearExisting = false) => async (dispatch, getState) => {
  try {
    dispatch({ type: IMPORT_TATA_RECORDS_REQUEST });
    dispatch({ type: IMPORT_TATA_PROGRESS_RESET });

    const {
      userLogin: { userInfo },
    } = getState();

    const formData = new FormData();
    formData.append('file', file);
    if (clearExisting) {
      formData.append('clearExisting', 'true');
    }

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userInfo.token}`,
      },
      timeout: 300000, // 5 minutes timeout for large files
    };

    const { data } = await axios.post(`${baseUrl}/tata/import`, formData, config);

    dispatch({
      type: IMPORT_TATA_RECORDS_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: IMPORT_TATA_RECORDS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Update import progress (for real-time progress tracking)
export const updateImportProgress = (progressData) => (dispatch) => {
  dispatch({
    type: IMPORT_TATA_PROGRESS_UPDATE,
    payload: progressData,
  });
};

// Reset import progress
export const resetImportProgress = () => (dispatch) => {
  dispatch({ type: IMPORT_TATA_PROGRESS_RESET });
};

// Export TATA records
export const exportTataRecords = () => async (dispatch, getState) => {
  try {
    dispatch({ type: EXPORT_TATA_RECORDS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob',
    };

    const { data } = await axios.get(`${baseUrl}/tata/export`, config);

    const url = URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'TATA_Export.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);

    dispatch({
      type: EXPORT_TATA_RECORDS_SUCCESS,
      payload: 'Export completed successfully',
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: EXPORT_TATA_RECORDS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get TATA statistics
export const fetchTataStats = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_TATA_STATS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${baseUrl}/tata/stats`, config);

    dispatch({
      type: GET_TATA_STATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_TATA_STATS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get TATA records by filters
export const fetchTataByFilters = (filters) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_TATA_BY_FILTERS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Convert filters object to query string
    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const { data } = await axios.get(`${baseUrl}/tata/filters?${queryParams.toString()}`, config);

    dispatch({
      type: GET_TATA_BY_FILTERS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: GET_TATA_BY_FILTERS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const syncTataTaskStatus = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: 'SYNC_TATA_TASK_STATUS_REQUEST',
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.post(
      `${baseUrl}/tata/sync-status`,
      {},
      config
    );

    dispatch({
      type: 'SYNC_TATA_TASK_STATUS_SUCCESS',
      payload: data,
    });

    return data; // Return data including updatedRecords
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: 'SYNC_TATA_TASK_STATUS_FAIL',
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

// Add this function at the end of your TataAction.js file
export const getFieldExecutives = (search = '') => async (dispatch, getState) => {
  try {
    dispatch({
      type: 'GET_FIELD_EXECUTIVES_REQUEST',
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.get(
      `${baseUrl}/tata/field-executives?search=${encodeURIComponent(search)}`,
      config
    );

    dispatch({
      type: 'GET_FIELD_EXECUTIVES_SUCCESS',
      payload: data,
    });

    return data; // Return the data
  } catch (error) {
    if (error.response?.status === 401) {
      dispatch(logout());
      return;
    }
    dispatch({
      type: 'GET_FIELD_EXECUTIVES_FAIL',
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error; // Throw error so it can be caught
  }
};



